module.exports = __webpack_public_path__ + "img/R_REF_W.31765132.svg";